import { EnrolmentFreshness } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getEligibilityStatus: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<EnrolmentFreshness> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/partners/eligibility/status`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<EnrolmentFreshness>(fetchContext.errorStore, response, 'get eligibility status'));
